/**
 * No em dashes on the front end. Headlines come from outside sources and
 * sometimes carry them; this is the same rule the pipeline applies on save,
 * for anything stored before it did.
 */
export function noDashes(s: string): string
export function noDashes(s: string | null | undefined): string | null | undefined
export function noDashes(s: string | null | undefined) {
  if (!s) return s
  return s.replace(/\s+[—–]\s+/g, ': ').replace(/—/g, ', ').replace(/:\s*:/g, ':')
}
